import React from "react";
import PropTypes from "prop-types";
import "./Button.css";
import Icon from "../Icon/Icon";
/**
 * @desc Button in application
 * @param props
 * @return null
 */
const getClassStyle = size =>
  ({
    primary: "ui-button--primary",
    secondary: "ui-button--secondary",
    lesser: "ui-button--lesser",
    link: "ui-button--link"
  }[size]);

const getClassSize = size =>
  ({
    small: "ui-button--small",
    medium: "ui-button--medium",
    large: "ui-button--large"
  }[size]);

const getClassWidth = width =>
  ({
    full: "ui-button--full"
  }[width]);

const Button = props => {
  const { className, ...other } = props;
  const classDisabled = props.disabled ? "ui-button--disabled" : "";
  const disabled = props.disabled ? "disabled" : "";
  const classSize = props.size ? getClassSize(props.size) : "";
  const classWidth = props.width ? getClassWidth(props.width) : "";
  const classStyle = props.uistyle ? getClassStyle(props.uistyle) : "";
  const classRounded = props.rounded ? "ui-button--rounded" : "";
  const iconColor = props.buttonIconColor ? props.buttonIconColor : "white";
  const classIconPosition = props.buttoniconposition
    ? "ui-button--icon-" + props.buttoniconposition
    : "";
  const icon = props.buttonicon ? (
    <Icon
      icon={props.buttonicon}
      className={classIconPosition}
      color={iconColor}
    />
  ) : (
    ""
  );
  const buttonIconAlone = props.buttonIconAlone ? true : false;
  const buttonIconAloneStyle = props.buttonIconAlone
    ? "ui-button--icon-alone"
    : "";
  return (
    <button
      disabled={disabled}
      className={
        "ui-button " +
        className +
        " " +
        classDisabled +
        " " +
        classSize +
        " " +
        classWidth +
        " " +
        classStyle +
        " " +
        classRounded +
        " " +
        buttonIconAloneStyle
      }
      {...other}
      onClick={props.onClick}
    >
      <span className="ui-button__icon">{icon}</span>
      {!buttonIconAlone ? (
        <span className="ui-button__children">{props.children}</span>
      ) : (
        ""
      )}
    </button>
  );
};

Button.propTypes = {
  /** ClassName will be injected into the component's container (not the button element itself). You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** Enable or disable the button. */
  disabled: PropTypes.bool,
  /** Button style options: primary, secondary, lesser. */
  uistyle: PropTypes.string,
  /** Button size options: small, medium, large. */
  size: PropTypes.string,
  /** Width can either be "inline" (simply the width naturally to fit content), or "full" (100% width). */
  width: PropTypes.string,
  /** Rounded is a boolean property, simply used to determine if the button has very  corners. */
  rounded: PropTypes.bool,
  buttonicon: PropTypes.string,
  buttoniconposition: PropTypes.oneOf(["left", "right", ""])
};

Button.defaultProps = {
  className: "",
  disabled: false,
  uistyle: "primary",
  size: "medium",
  width: "inline",
  rounded: false,
  buttonicon: "",
  buttoniconposition: ""
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/UI/Button/Button.js